export default __webpack_public_path__ + "static/media/grundo.07c17e7c.png";